module.exports = __webpack_public_path__ + "img/流体力学2_4_4.f7ff237a.jpg";